import { initReactI18next } from 'react-i18next';
import en from './en.json';
import i18next from 'i18next';

export const LANGUAGE_EN = 'en';

export const translationsJson = {
  [LANGUAGE_EN]: {
    dashboard: en.dashboard,
    general_settings: en.general_settings,
    locations: en.locations,
    pickupSettings: en.pickupSettings,
    deliverySettings: en.deliverySettings,
    widget_settings: en.widget_settings,
    shippingSettings: en.shippingSettings,
    orderReport: en.orderReport,
    pricing: en.pricing,
    onboarding: en.onboarding,
    translation: en.translation,
  },
};

export const languages = Object.keys(translationsJson);
export const DEFAULT_LANGUAGE = LANGUAGE_EN;

export const i18n = i18next.use(initReactI18next).init({
  resources: translationsJson,
  fallbackLng: 'en',
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
